// extracted by mini-css-extract-plugin
export var csatScore = "_mm-5";
export var header = "_mm-1";
export var panelWrapper = "_mm-2";
export var postPreview = "_mm-3";
export var rightContent = "_mm-0";
export var wrappingText = "_mm-4";